<div class="flex w-full flex-col items-center justify-center flex-grow  bg-gray-100 px-6">
  <!-- Header -->
  <div class="flex items-center space-x-2">
    <img src="assets/images/logo/booking.png" alt="LollyLaw Calendar" class="h-8 w-8" />
    <h1 class="text-2xl font-semibold text-gray-700">Bookings</h1>
  </div>

  <!-- Main Content -->
  <div class="mt-8 text-center">
    <mat-icon
    class="text-red-500 icon-size-16"
    [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
    <h2 class="text-3xl font-bold text-gray-900">{{title}}</h2>
    <p class="mt-2 text-gray-600">
      {{errorMessage}}
    </p>
  </div>

  <!-- Info Card -->
  <mat-card class="mt-6 p-6 max-w-lg text-center shadow-lg">
    <h3 class="text-xl font-semibold text-gray-800">
      Online booking by LollyLaw Schduler
    </h3>
    <p class="mt-2 text-gray-600">
      Take the pain out of scheduling bookings by integrating your own dedicated booking page with LollyLaw Schduler.
    </p>
    <a href="https://lollylaw.com/privacy-policy"
      class="mt-4 inline-block text-blue-600 font-medium hover:underline">
      Learn more about LollyLaw Appointment Schduler
    </a>
  </mat-card>
</div>
